var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRespect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E8ECFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_20384)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_20384",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V26H6V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_20384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8334 14.3337C21.8334 6.83366 18.5001 6.83366 18.5001 6.83366C18.5001 6.83366 16.8334 6.83366 16.0001 8.50033C15.1667 6.83366 13.5001 6.83366 13.5001 6.83366C13.5001 6.83366 10.1667 6.83366 10.1667 14.3337C10.1667 14.3337 11.8334 15.167 16.0001 15.167C20.1667 15.167 21.8334 14.3337 21.8334 14.3337Z",
    stroke: "#2C3E4B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 21.0003C13.4009 21.0003 14.3334 21.9328 14.3334 23.0837C14.3334 24.2345 13.4009 25.167 12.2501 25.167C11.0992 25.167 10.1667 24.2345 10.1667 23.0837C10.1667 21.9328 11.0992 21.0003 12.2501 21.0003Z",
    stroke: "#2C3E4B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8334 23.0837C21.8334 24.2345 20.9009 25.167 19.7501 25.167C18.5992 25.167 17.6667 24.2345 17.6667 23.0837C17.6667 21.9328 18.5992 21.0003 19.7501 21.0003C20.9009 21.0003 21.8334 21.9328 21.8334 23.0837Z",
    stroke: "#2C3E4B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 23.084C14.3334 23.084 15.1667 22.6673 16 22.6673C16.8334 22.6673 17.6667 23.084 17.6667 23.084",
    stroke: "#2C3E4B",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8334 14.0717C23.8692 14.5308 25.1667 15.2242 25.1667 16C25.1667 17.3817 21.0625 18.5 16 18.5C10.9375 18.5 6.83337 17.3817 6.83337 16C6.83337 15.2242 8.13087 14.5308 10.1667 14.0717",
    stroke: "#2C3E4B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_20384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespect);
export default __webpack_public_path__ + "static/media/respect.23d49101d989bd33ebd446e9f3eeae3d.svg";
export { ForwardRef as ReactComponent };